import { render, staticRenderFns } from "./ModalAccountPay.vue?vue&type=template&id=6a55f94e&"
import script from "./ModalAccountPay.vue?vue&type=script&lang=js&"
export * from "./ModalAccountPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports